import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ToggleBlock = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11357 4.17311C5.30727 3.84049 5.06825 3.4229 4.68333 3.42149L2.02366 3.41172C1.6368 3.4103 1.39495 3.82992 1.59011 4.16395L2.92495 6.44863C3.11812 6.77926 3.59603 6.77892 3.78873 6.44802L5.11357 4.17311ZM6.75 5C6.75 4.58579 7.08579 4.25 7.5 4.25H17.5C17.9142 4.25 18.25 4.58579 18.25 5C18.25 5.41421 17.9142 5.75 17.5 5.75L7.5 5.75C7.08579 5.75 6.75 5.41421 6.75 5ZM12.4999 10.75H17.5C17.9142 10.75 18.25 10.4142 18.25 10C18.25 9.58579 17.9142 9.25 17.5 9.25H12.4999C12.0857 9.25 11.7499 9.58579 11.7499 10C11.7499 10.4142 12.0857 10.75 12.4999 10.75ZM12.4999 15.75H17.5C17.9142 15.75 18.25 15.4142 18.25 15C18.25 14.5858 17.9142 14.25 17.5 14.25H12.4999C12.0857 14.25 11.7499 14.5858 11.7499 15C11.7499 15.4142 12.0857 15.75 12.4999 15.75ZM6.8115 8.7469C6.81291 8.36199 7.23049 8.12296 7.56312 8.31667L9.75934 9.59567C10.0902 9.78838 10.0906 10.2663 9.75995 10.4595L7.55429 11.7481C7.22026 11.9433 6.80064 11.7014 6.80206 11.3146L6.8115 8.7469ZM7.56312 13.2898C7.2305 13.0961 6.81292 13.3351 6.8115 13.7201L6.80207 16.2877C6.80065 16.6746 7.22027 16.9164 7.5543 16.7213L9.75996 15.4326C10.0906 15.2394 10.0902 14.7615 9.75935 14.5688L7.56312 13.2898Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ToggleBlock
